import { gql } from '@apollo/client';

// ********************************************
//                   FRAGMENTS
// ********************************************
export const AttributeValueFragment = gql`
  fragment CommonAttributeValueFields on AbstractAttributeValue {
    attributeId
    name
    ownerOrganizationId
    type
    attributeValueId
    entityIdentifier
    entityDomain
    effectiveFromReportingDate
    displayName
  }

  # the typed value of each attribute-value kind, aliased per kind because the
  # members' value fields have different types
  fragment AttributeValueTypedValues on AttributeValue {
    __typename
    ... on StringAttributeValue {
      stringValue: value
    }
    ... on FloatAttributeValue {
      floatValue: value
    }
    ... on IntegerAttributeValue {
      integerValue: value
    }
    ... on BooleanAttributeValue {
      booleanValue: value
    }
    ... on PercentageRateAttributeValue {
      percentageRateValue: value
    }
    ... on FullDateStrAttributeValue {
      fullDateStrValue: value
    }
    ... on StringArrayAttributeValue {
      stringArrayValue: value
    }
  }

  fragment AttributeValueFragment on AttributeValue {
    __typename

    ...CommonAttributeValueFields
    ...AttributeValueTypedValues

    ... on StringAttributeValue {
      stringValidation: validation {
        type
        allowedValues
      }
    }

    ... on FloatAttributeValue {
      floatValidation: validation {
        type
        display {
          ... on AttributeValueCurrencyDisplay {
            displayType
            currencyCode
          }
        }
      }
    }

    ... on IntegerAttributeValue {
      integerValidation: validation {
        type
      }
    }

    ... on BooleanAttributeValue {
      booleanValidation: validation {
        type
      }
    }

    ... on PercentageRateAttributeValue {
      percentageRateValidation: validation {
        type
      }
    }

    ... on FullDateStrAttributeValue {
      fullDateStrValidation: validation {
        type
      }
    }

    ... on StringArrayAttributeValue {
      stringArrayValidation: validation {
        type
        allowedValues
      }
    }
  }
`;
export const AttributeFragment = gql`
  fragment AttributeFragment on Attribute {
    attributeId
    displayName
    type
    validation {
      type
      allowedValues
      display {
        ... on AttributeValueCurrencyDisplay {
          displayType
          currencyCode
        }
      }
    }
    attributeValue {
      ...AttributeValueFragment
    }
    attributeValues {
      ...AttributeValueFragment
    }
  }
  ${AttributeValueFragment}
`;

// ********************************************
//                   QUERIES
// ********************************************

export const GET_ATTRIBUTE_LIST_BY_ENTITY = gql`
  query GetAttributeListByEntity(
    $organizationId: UUID!
    $listName: String!
    $entityDomain: AttributeEntityDomain!
    $entityIdentifier: UUID
  ) {
    attributes: getAttributeListByEntity(
      organizationId: $organizationId
      listName: $listName
      entityDomain: $entityDomain
      entityIdentifier: $entityIdentifier
    ) {
      ...AttributeFragment
    }
  }
  ${AttributeFragment}
`;

// ********************************************
//                   MUTATIONS
// ********************************************

export const CREATE_OR_UPDATE_LATEST_ATTRIBUTE_VALUE = gql`
  mutation CreateOrUpdateLatestAttributeValue(
    $input: CreateOrUpdateLatestAttributeValueInput!
  ) {
    createOrUpdateLatestAttributeValue(input: $input) {
      response
    }
  }
`;
